import React, { useState, useEffect } from "react";
import { createGrammarTopic, updateGrammarTopic } from "./adminGrammarService";
import ImagePickerModal from "../../media_images/ImagePickerModal";
import "./grammarForm.css";

const BASE_ROOT = process.env.REACT_APP_BASE_URL_ROOT || "";
const toPublicUrl = (url) => url?.replace(/\/api(?:\/admin)?\/media-images\//, "/api/public/media-images/") ?? url;
const toImgSrc = (url) => {
  if (!url) return "";
  const src = toPublicUrl(url.startsWith("http") ? url : `${BASE_ROOT}${url}`);
  console.log("[GrammarTopicForm] img raw:", url, "→ resolved:", src);
  return src;
};

const GrammarTopicForm = ({ topic, onSaved, onCancel }) => {
  const isEdit = !!topic;
  const [form, setForm] = useState({ title: "", description: "", icon: "", sortOrder: "" });
  const [coverImage, setCoverImage] = useState(null); // { mediaImageId, url }
  const [pickerOpen, setPickerOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (topic) {
      setForm({ title: topic.title || "", description: topic.description || "", icon: topic.icon || "", sortOrder: topic.sortOrder ?? "" });
      const ci = topic.coverImageUrl ? { mediaImageId: topic.coverImageId, url: topic.coverImageUrl } : null;
      console.log("[GrammarTopicForm] topic loaded — coverImageId:", topic.coverImageId, "coverImageUrl:", topic.coverImageUrl);
      console.log("[GrammarTopicForm] coverImage state set to:", ci);
      console.log("[GrammarTopicForm] toImgSrc result:", toImgSrc(topic.coverImageUrl));
      setCoverImage(ci);
    }
  }, [topic]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleCoverSelect = (url) => {
    const match = url.match(/\/api(?:\/public)?\/media-images\/(\d+)\/file/);
    const mediaImageId = match ? Number(match[1]) : null;
    console.log("[GrammarTopicForm] cover image selected — url:", url, "mediaImageId:", mediaImageId);
    if (mediaImageId) setCoverImage({ mediaImageId, url });
    else console.warn("[GrammarTopicForm] could not extract mediaImageId from url:", url);
  };

  const handleSubmit = async () => {
    setError("");
    if (!form.title.trim() || !form.description.trim()) { setError("Title and Description are required."); return; }
    const payload = {
      ...form,
      sortOrder: form.sortOrder !== "" ? Number(form.sortOrder) : null,
      coverImageId: coverImage?.mediaImageId ?? null,
    };
    console.log("[GrammarTopicForm] coverImage state:", coverImage);
    console.log("[GrammarTopicForm] payload:", JSON.stringify(payload, null, 2));
    setLoading(true);
    const res = isEdit ? await updateGrammarTopic(topic.id, payload) : await createGrammarTopic(payload);
    console.log("[GrammarTopicForm] response:", res);
    setLoading(false);
    if (res.status === 200 || res.status === 201) onSaved();
    else setError(res.message || "Operation failed.");
  };

  return (
    <div className="gf-inline-panel">
      <div className="gf-inline-header">
        <span className="gf-inline-title">{isEdit ? "Edit" : "New"} Grammar Topic</span>
        <button type="button" className="gf-icon-btn" onClick={onCancel}>✕</button>
      </div>
      {error && <div className="gf-error">{error}</div>}

      <div className="gf-row">
        <div className="gf-field gf-field--xs">
          <label className="gf-label">Icon</label>
          <input name="icon" placeholder="📝" value={form.icon} onChange={handleChange} className="gf-input" />
        </div>
        <div className="gf-field gf-field--grow">
          <label className="gf-label">Title <span className="gf-required">*</span></label>
          <input name="title" placeholder="e.g. Parts of Speech" value={form.title} onChange={handleChange} className="gf-input" />
        </div>
        <div className="gf-field gf-field--xs">
          <label className="gf-label">Sort</label>
          <input name="sortOrder" type="number" placeholder="1" value={form.sortOrder} onChange={handleChange} className="gf-input" />
        </div>
      </div>

      <div className="gf-field">
        <label className="gf-label">Description <span className="gf-required">*</span></label>
        <textarea name="description" rows={2} placeholder="Brief description…" value={form.description} onChange={handleChange} className="gf-input gf-textarea" />
      </div>

      {/* Cover Image */}
      <div className="gf-field">
        <label className="gf-label">Cover Image</label>
        {coverImage ? (
          <div className="gf-cover-preview">
            <img src={toImgSrc(coverImage.url)} alt="cover" className="gf-cover-thumb" />
            <button type="button" className="gf-icon-btn gf-icon-btn--danger" onClick={() => setCoverImage(null)}>✕ Remove</button>
          </div>
        ) : (
          <button type="button" className="gf-add-btn" onClick={() => setPickerOpen(true)}>🖼 Pick Cover Image</button>
        )}
        {coverImage && (
          <button type="button" className="gf-text-btn" style={{ marginTop: 4 }} onClick={() => setPickerOpen(true)}>Change image</button>
        )}
      </div>

      <div className="gf-actions">
        <button type="button" onClick={handleSubmit} disabled={loading} className="gf-btn gf-btn--primary">{loading ? "Saving…" : isEdit ? "Update" : "Create"}</button>
        <button type="button" onClick={onCancel} disabled={loading} className="gf-btn gf-btn--secondary">Cancel</button>
      </div>

      <ImagePickerModal isOpen={pickerOpen} onClose={() => setPickerOpen(false)} onSelect={(url) => { handleCoverSelect(url); setPickerOpen(false); }} defaultImageUse="GENERAL" />
    </div>
  );
};

export default GrammarTopicForm;
